import api from "../../index";

export const GetClientDashboard = () => api.post("client-dashboard");
export const GetBannerDashboard = () => api.post("bannerlist");
export const GetDocumentApi = (id) => api.post(`document-view/${id}`);
export const SubmitSignatureApi = (data, headers) => api.post('signature-submit', data, headers);
export const VerifyDocument = (data) => api.post("verify-doc-by-client",data);
export const RejectVerifyDoc = (data) => api.post("update-reason-of-review-doc",data);
export const SetMpinApi = (data) => api.post("update-mpin",data);
